import { motion } from "framer-motion";
import { ArrowDownRight } from "lucide-react";
import { scrollToId } from "@/lib/api";

export const BundlePromo = () => (
  <section data-testid="bundle-promo-section" className="px-5 py-12 md:px-10 md:py-20">
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className="relative mx-auto max-w-[1440px] overflow-hidden rounded-[40px] bg-violet px-6 py-14 md:px-16 md:py-24"
    >
      <div className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-pink/50 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 left-1/3 h-72 w-72 rounded-full bg-lime/30 blur-3xl" />
      <span className="relative inline-block -rotate-3 rounded-full bg-pink px-4 py-2 font-mono text-xs font-bold uppercase tracking-widest">
        Bundle deal · Save 496 Rs
      </span>
      <h2 data-testid="bundle-promo-title" className="relative mt-8 font-display text-[clamp(2.3rem,7.4vw,7.5rem)] font-extrabold uppercase leading-[0.88] tracking-[-0.04em]">
        Get 5 Insane Pairs <br className="hidden md:block" />for just <span className="text-lime">999 Rs</span>
      </h2>
      <div className="relative mt-10 flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="max-w-md text-base text-white/85 md:text-lg">Mix and match Burning Fire and Insane Heroes. Add any 5 pairs to your bag and the price drops automatically.</p>
        <motion.button
          data-testid="bundle-promo-cta"
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => scrollToId("shop")}
          className="group flex w-fit items-center gap-3 whitespace-nowrap rounded-full bg-lime py-4 pl-6 pr-4 font-display text-base font-extrabold uppercase text-ink sm:pl-7 sm:text-lg"
        >
          Build your 5-pack
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-ink text-lime transition-transform duration-300 group-hover:rotate-[-45deg]">
            <ArrowDownRight className="h-5 w-5" />
          </span>
        </motion.button>
      </div>
    </motion.div>
  </section>
);
